module.exports = __webpack_public_path__ + "img/luggage.62fc7693.png";